import { render, staticRenderFns } from "./form-demo.vue?vue&type=template&id=34809f08&scoped=true&"
import script from "./form-demo.vue?vue&type=script&lang=js&"
export * from "./form-demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34809f08",
  null
  
)

export default component.exports